import { render, staticRenderFns } from "./MetadataComponent.vue?vue&type=template&id=1b25d3d3&scoped=true&"
import script from "./MetadataComponent.vue?vue&type=script&lang=ts&"
export * from "./MetadataComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MetadataComponent.vue?vue&type=style&index=0&id=1b25d3d3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b25d3d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VForm,VProgressCircular,VRow})
